export class DataSourceMapping {
  constructor(
    public manufacturerName: string,
    public originalId: string | null,
    public currentId: string | null,
  ) {}
}
